
import * as actionTypes from './actionTypes';

export const getStaticIps = () => {
  return {
    type: actionTypes.GET_STATIC_IP
  };
};

export const getStaticIpsSuccess = (payload) => ({
  type: actionTypes.GET_STATIC_IP_SUCCESS,
  payload
});

export const getStaticIpsFail = () => ({
  type: actionTypes.GET_STATIC_IP_FAIL
});

export const getStaticIpsLoading = () => ({
  type: actionTypes.GET_STATIC_IP_LOADING
});

export const setStaticIpsFailedMessage = (info) => ({
  type: actionTypes.SET_STATIC_IP_FAIL_MESSAGE,
  info
}); 

export const resetStaticIpsErrorSuccess = () => {
  return {
    type: actionTypes.RESET_STATIC_IP_ERROR_SUCCESS
  }
}
export const setStaticIp = (payload) => {
  return {
    type: actionTypes.SET_STATIC_IP,
    payload
  };
};

export const setStaticIpSuccess = (payload) => ({
  type: actionTypes.SET_STATIC_IP_SUCCESS,
  payload
});

export const setStaticIpFail = () => ({
  type: actionTypes.SET_STATIC_IP_FAIL
});

export const setStaticIpLoading = () => ({
  type: actionTypes.SET_STATIC_IP_LOADING
});

export const deleteStaticIpInfoDetails = (info) => {
  return {
    type: actionTypes.DELETE_STATIC_IP_INFO,
    info
  }
}

export const deleteStaticIpSuccess = (info) => {
  return {
    type: actionTypes.DELETE_STATIC_IP_INFO_SUCCESS,
    info
  }
}

export const deleteStaticIpFailed = (info) => {
  return {
    type: actionTypes.DELETE_STATIC_IP_INFO_FAILED,
    info
  }
}

export const setUpstreamError = () => ({
  type: actionTypes.SET_UPSTREAM_ERROR
});

export const resetUpstreamError = () => ({
  type: actionTypes.RESET_UPSTREAM_ERROR
});